import styles from "./TypingDots.module.css";

const TypingDots = () => {
  return (
    <div 
      className={styles.container}
      role="status"
      aria-live="polite" 
      aria-label="Hjälprobot skriver"
    >
      <span className={styles.dot}></span>
      <span className={styles.dot}></span>
      <span className={styles.dot}></span>
    </div>
  );
};

export default TypingDots;
